export enum TokenType {
    Refresh = 'refresh_token',
    Guest = 'guest',
    SessionId = 'session_id',
}
